<template>
  <el-card class="main-card">
    <template #header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">小程序商城</el-breadcrumb-item>
        <el-breadcrumb-item>小程序订单管理</el-breadcrumb-item>
      </el-breadcrumb>
    </template>
    <el-form :model="querys" ref="querys" label-width="90px" class="search-form" size="default">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="关键词" prop="keyword">
            <el-input v-model="querys.keyword" prefix-icon="Search" placeholder="订单号/收货人/联系电话" @keyup.enter="fetchs"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item label="订单状态" prop="orderStatus">
            <el-select v-model="querys.orderStatus" placeholder="请选择" clearable>
              <el-option label="已取消" value="-1"></el-option>
              <el-option label="未支付" value="0"></el-option>
              <el-option label="已支付" value="1"></el-option>
              <el-option label="已发货" value="2"></el-option>
              <el-option label="已完成" value="3"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item label="支付状态" prop="payStatus">
            <el-select v-model="querys.payStatus" placeholder="请选择" clearable>
              <el-option label="未支付" value="0"></el-option>
              <el-option label="已支付" value="1"></el-option>
              <el-option label="整单退" value="-1"></el-option>
              <el-option label="部分退" value="-5"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="联系电话" prop="receiverPhone">
            <el-input v-model="querys.receiverPhone" placeholder="请输入联系电话"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="" label-width="20px">
            <el-button type="primary" icon="Search" @click="fetchs()">
              搜索
            </el-button>
            <el-button icon="Refresh" @click="resetSearch()">
              重置
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div class="toolbar">
      <el-button 
        type="danger" 
        icon="Delete" 
        @click="del(selectedRow)">
        删除
      </el-button>
      <el-button 
        type="warning" 
        icon="Money" 
        :disabled="!currRow || !(currRow.cancelTime || currRow.cancelReason)"
        @click="goToRefund(currRow)">
        跳转退款列表
      </el-button>
      <el-button plain icon="Download" @click="exportData()" style="float: right;">导出数据</el-button>
    </div>

    <basic-table class="table"  :query="querys" @handler="fetchs" :currHandler="currHandler">
      <template v-slot:productImg="scope">
        <el-image style="height: 32px; width: 32px" lazy :src="apiUrl + 'static/code/' + scope.row.productCode + '?t=0'"
          :preview-src-list="[apiUrl + 'static/code/' + scope.row.productCode + '?t=1']">
          <template #error>
            <img style="width: 100%" src="~@/assets/imgunfine.jpg" alt="" />
          </template>
        </el-image>
      </template>
      <template v-slot:orderStatus="scope">
        <el-tag :type="getOrderStatusType(scope.row.orderStatus)">
          {{ getOrderStatusText(scope.row.orderStatus) }}
        </el-tag>
      </template>
      <template v-slot:payStatus="scope">
        <el-tag :type="getPayStatusType(scope.row.payStatus)">
          {{ getPayStatusText(scope.row.payStatus) }}
        </el-tag>
      </template>
      <template v-slot:toolbar="scope">
        <!-- <el-button @click="edit(scope.row)" type="primary" link size="small">
          [编辑]
        </el-button> -->
        <el-button @click="watchOrder(scope.row)" type="primary" link size="small">
          [查看]
        </el-button>
      </template>
    </basic-table>

    <static-dialog ref="dialog" class="dialog" title="商品信息维护" :opened="opened" :ok="submit">
      <el-form :model="forms" :rules="rules" ref="forms" :label-width="labelWidth">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <el-form-item label="商品类别" prop="metalCode">
              <el-select v-model="forms.metalCode" placeholder="请选择" @change="chooseOption($event, dict.metals)"
                :disabled="forms.id">
                <el-option v-for="item in dict.metals" :key="item.id" :label="item.value" :value="item.name">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16">
            <el-form-item label="商品名称" prop="productName" style="max-width: 95%">
              <el-input v-model="forms.productName" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item label="图片上传" prop="productTags">
              <el-upload :action="apiUrl + '/ShopProduct/Uploader?dataType=main&productCode=' + forms.productCode"
                list-type="picture-card" :on-success="uploadHandleSuccess" :on-remove="uploadHandleRemove"
                :before-upload="uploadHandleBefore" :file-list="fileList">
                <el-icon>
                  <Plus />
                </el-icon>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </static-dialog>

    <static-dialog ref="detailDialog" class="dialog" title="订单详情" :opened="detailOpened" :okVisible="false" width="65%">
      <div v-if="orderDetail">
        <el-row :gutter="30">
          <el-col :span="24">
            <el-card class="box-card" style="margin-bottom: 20px;">
              <template #header>
                <div class="card-header">
                  <span>订单基本信息</span>
                </div>
              </template>
              <el-row :gutter="10">
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="label">订单号：</span>
                    <span class="value">{{ orderDetail.order.orderNo }}</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="label">订单状态：</span>
                    <el-tag :type="getOrderStatusType(orderDetail.order.orderStatus)">
                      {{ getOrderStatusText(orderDetail.order.orderStatus) }}
                    </el-tag>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="label">支付状态：</span>
                    <el-tag :type="getPayStatusType(orderDetail.order.payStatus)">
                      {{ getPayStatusText(orderDetail.order.payStatus) }}
                    </el-tag>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="label">订单金额：</span>
                    <span class="value">¥{{ orderDetail.order.totalAmount }}</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="label">实付金额：</span>
                    <span class="value">¥{{ orderDetail.order.payAmount }}</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="label">运费：</span>
                    <span class="value">¥{{ orderDetail.order.freight }}</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="label">下单时间：</span>
                    <span class="value">{{ orderDetail.order.orderDate }}</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="label">支付时间：</span>
                    <span class="value">{{ orderDetail.order.payTime || '未支付' }}</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="label">发货时间：</span>
                    <span class="value">{{ orderDetail.order.deliveryTime || '未发货' }}</span>
                  </div>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-card class="box-card" style="margin-bottom: 20px;">
              <template #header>
                <div class="card-header">
                  <span>收货信息</span>
                </div>
              </template>
              <el-row :gutter="10">
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="label">收货人：</span>
                    <span class="value">{{ orderDetail.order.receiverName }}</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="label">联系电话：</span>
                    <span class="value">{{ orderDetail.order.receiverPhone }}</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="detail-item">
                    <span class="label">邮编：</span>
                    <span class="value">{{ orderDetail.order.receiverZipCode }}</span>
                  </div>
                </el-col>
                <el-col :span="24">
                  <div class="detail-item">
                    <span class="label">收货地址：</span>
                    <span class="value">
                      {{ orderDetail.order.receiverCountry }} {{ orderDetail.order.receiverProvince }} 
                      {{ orderDetail.order.receiverCity }} {{ orderDetail.order.receiverDistrict }} 
                      {{ orderDetail.order.receiverStreet }} {{ orderDetail.order.receiverAddress }}
                    </span>
                  </div>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-card class="box-card">
              <template #header>
                <div class="card-header">
                  <span>商品明细</span>
                </div>
              </template>
              <el-table :data="orderDetail.details" border style="width: 100%">
                <el-table-column prop="productName" label="商品名称" width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="productCode" label="商品编码" width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="skuCode" label="SKU编码" width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="attributes" label="规格属性" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="unitPrice" label="单价" width="80">
                  <template #default="scope">
                    ¥{{ scope.row.unitPrice }}
                  </template>
                </el-table-column>
                <el-table-column prop="quantity" label="数量" width="60"></el-table-column>
                <el-table-column prop="subtotal" label="小计" width="80">
                  <template #default="scope">
                    ¥{{ scope.row.subtotal }}
                  </template>
                </el-table-column>
                <el-table-column prop="imgSrc" label="商品图片" width="120">
                  <template #default="scope">
                    <el-image 
                      v-if="scope.row.imgSrc" 
                      style="width: 40px; height: 40px" 
                      :src="scope.row.imgSrc" 
                      :preview-src-list="[scope.row.imgSrc]">
                    </el-image>
                    <span v-else>无图片</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </static-dialog>
  </el-card>
</template>
<script>
import { fetchFileList } from "@/api/basic";
import { fetchShopOrderList,fetchShopOrderdelete, delShopFile, fetchShopOrderDto, exportShopOrderDetail } from "@/api/shop";
import StaticDialog from "@/components/static-dialog.vue";
import BasicTable from "@/components/basic-table.vue";
export default {
  name: "order",
  components: { StaticDialog, BasicTable },
  data() {
    return {
      apiUrl: '',
      productCode: "",
      querys: {
        keyword: "",
        orderStatus: "",
        payStatus: "",
        receiverPhone: "",
        userId: "",
        orderId: "",
        filters: [],
        columns: [
          { type: "index", label: "序号" },
          { prop: "orderNo", label: "订单编号", sortable: true, searchable: true, width: "150", showOverflowTooltip: true },
          { prop: "id", label: "订单ID", sortable: true, searchable: true, width: "190", showOverflowTooltip: true },
          { prop: "userID", label: "用户ID", sortable: true, searchable: true, width: "190", showOverflowTooltip: true },
          { prop: "orderDate", label: "下单时间", sortable: true, searchable: true, width: "140", showOverflowTooltip: true },
          { prop: "orderStatus", label: "订单状态", type: "template", sortable: true, searchable: true, width: "90" },
          { prop: "payStatus", label: "支付状态", type: "template", sortable: true, searchable: true, width: "90" },
          { prop: "totalAmount", label: "订单总额", sortable: true, searchable: true, width: "90", showOverflowTooltip: true },
          { prop: "payAmount", label: "实付金额", sortable: true, searchable: true, width: "90", showOverflowTooltip: true },
          { prop: "receiverName", label: "收货人", sortable: true, searchable: true, width: "80", showOverflowTooltip: true },
          { prop: "receiverPhone", label: "联系电话", sortable: true, searchable: true, width: "100", showOverflowTooltip: true },
          { prop: "receiverAddress", label: "收货地址", sortable: true, searchable: true, width: "200", showOverflowTooltip: true },
          { prop: "platformPayNo", label: "平台支付流水号", sortable: true, searchable: true, width: "160", showOverflowTooltip: true },
          { prop: "receiverProvince", label: "省", sortable: true, searchable: true, width: "80", showOverflowTooltip: true },
          { prop: "receiverCity", label: "市", sortable: true, searchable: true, width: "80", showOverflowTooltip: true },
          { prop: "receiverDistrict", label: "区/县", sortable: true, searchable: true, width: "80", showOverflowTooltip: true },
          { prop: "cancelTime", label: "取消时间", sortable: true, searchable: true, width: "140", showOverflowTooltip: true },
          { prop: "cancelReason", label: "取消原因", sortable: true, searchable: true, width: "140", showOverflowTooltip: true },
          { type: "toolbar", label: "操作", width: "100", fixed: "right" }

        ],
        sidx: "id",
        sord: "descending",
        page: 1,
        rows: 10,
        records: 0,
      },
      currRow: null,
      selectedRow: null, // 当前选中的行
      centerDialogVisible: false,
      dialogWidth: "30%",

      dict: {
        categorys: [],
        brands: [],
        factorys: [],
      },
      forms: {},
      labelWidth: "110px",
      rules: {
        // category: [
        //   { required: true, message: "请选择商品大类", trigger: "blur" },
        // ],
        productName: [
          { required: true, message: "请输入商品名称", trigger: "blur" },
          { min: 1, max: 30, message: "长度在1-30之间", trigger: "blur" },
        ],
        // purchasePrice: [
        //   { required: true, message: "请输入采购参考价格", trigger: "blur" },
        // ],
        // sellPrice: [
        //   { required: true, message: "请输入售卖预估价格", trigger: "blur" },
        // ],
        brandName: [
          { required: true, message: "请选择所属品牌", trigger: "blur" },
        ],
        factoryName: [
          { required: true, message: "请选择对应工厂", trigger: "blur" },
        ],
      },
      //fileList:[{name: 'food.jpg', url: 'https://xxx.cdn.com/xxx.jpg'}]
      fileList: [],
      orderDetail: null
    };
  },
  mounted() {
    // 检查URL参数，如果有keyword参数则设置到搜索框中
    if (this.$route.query.keyword) {
      this.querys.keyword = this.$route.query.keyword;
    }
    
    if (this.$route.query.userId) {
      this.querys.userId = this.$route.query.userId;
    }
    
    if (this.$route.query.orderId) {
      this.querys.orderId = this.$route.query.orderId;
    }
    
    this.fetchs();

    // this.$kaung.dictionary("stock", "category").then((res) => {
    //   this.dict.categorys = res;
    // });
    this.$kaung.dictionary("stock", "brand").then((res) => {
      this.dict.brands = res;
    });
    this.$kaung.dictionary("stock", "factory").then((res) => {
      this.dict.factorys = res;
    });

    this.apiUrl = process.env.VUE_APP_BASEURL;
  },
  methods: {
    add() {
      this.currRow = {};
      this.$refs.dialog.toggle();
    },
    edit(row) {
      this.currRow = row;
      this.$refs.dialog.toggle();
    },
    del(row) {
      if (!row) {
        this.$message({
          type: 'warning',
          message: '请先选择要删除的订单'
        });
        return;
      }
      
      this.currRow = row;
      let that = this;

      this.$confirm("此操作将删除本行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        fetchShopOrderdelete(that.currRow.id).then((res) => {
          that.$message({
            type: res.type,
            message: res.content,
          });
          that.fetchs();
        });
      });
    },
    chooseOption(value, options) {
      let items = options.filter(function (item) {
        return item.value == value;
      });
      if (items && items.length > 0) {
        let that = this;
        fetchShopCode(items[0].attribute || "Z").then((res) => {
          that.forms.productCode = res.data;

          getPrevID().then((res) => {
            that.forms.id = res;
          });
        });
      }
    },
    opened() {
      let that = this;
      
    },
    submit() {
      let that = this;

      this.$refs.forms.validate((valid) => {
        if (!valid) return;

        // let chooseBrands = that.dict.brands.filter(function (item) {
        //   return item.value == that.forms.brandName;
        // });
        // let chooseFactorys = that.dict.factorys.filter(function (item) {
        //   return item.value == that.forms.factoryName;
        // });
        // if (chooseBrands.length == 0 || chooseFactorys.length == 0) {
        //   that.$message({
        //     message: "请重新选择工厂和品牌",
        //   });
        //   return;
        // }

        that.forms.brandCode = chooseBrands[0].name;
        // that.forms.factoryCode = chooseFactorys[0].name;
        submitShopinfo((that.currRow.id || ''), that.forms).then((res) => {
          that.$message({
            type: res.type,
            message: res.content,
          });

          if (res.data) {
            that.fetchs();
            that.$refs.dialog.toggle();
          }
        });
      });
    },
    fetchs() {
      this.querys.filters = [];
      
      
      // 订单状态筛选
      if (this.querys.orderStatus !== "") {
        this.querys.filters.push({
          name: "orderStatus",
          value: this.querys.orderStatus,
          operate: 0,
        });
      }
      
      // 支付状态筛选
      if (this.querys.payStatus !== "") {
        this.querys.filters.push({
          name: "payStatus",
          value: this.querys.payStatus,
          operate: 0,
        });
      }
      
      // 联系电话筛选
      if (this.querys.receiverPhone) {
        this.querys.filters.push({
          name: "receiverPhone",
          value: "%" + this.querys.receiverPhone.trim() + "%",
          operate: 5,
        });
      }
      
      // 用户ID筛选
      if (this.querys.userId) {
        this.querys.filters.push({
          name: "userID",
          value: this.querys.userId.trim(),
          operate: 0,
        });
      }
      
      // 订单ID筛选
      if (this.querys.orderId) {
        this.querys.filters.push({
          name: "id",
          value: this.querys.orderId.trim(),
          operate: 0,
        });
      }
      
      let { data, records, total, ...search } = {
        ...this.querys,
      };

      fetchShopOrderList(search).then((res) => {
        if (res.data) {
          this.querys.data = res.data.data || [];
          this.querys.records = res.data.records || 0;
        }
      });
    },
    currHandler(row) {
      this.currRow = row;
      this.selectedRow = row; // 同时设置选中行
    },
    pageHandler(page) {
      this.querys.page = page;
      this.fetchs();
    },
    sizeHandler(rows) {
      this.querys.rows = rows;
      this.fetchs();
    },
    sortHandler(order) {
      this.querys.sidx = order.prop;
      this.querys.sord = order.order;
      this.fetchs();
    },
    //控制dialog宽度与子组件控制关闭弹窗
    getdialogWidth(data) {
      if (data === "80%" || data === "30%") {
        this.dialogWidth = data;
      } else {
        this.centerDialogVisible = false;
      }
    },

    uploadHandleBefore(file) {
      console.log(file)
      if (!this.forms.id || !this.forms.productCode)
        return false;
    },
    uploadHandleRemove(file, fileList) {
      console.log(file.id, fileList)
      delShopFile(file.id).then((res) => {
        this.$message({
          type: res.type,
          message: res.content,
        });
      });
    },
    uploadHandleSuccess(res, file, fileList) {
      console.log(res, file, fileList)
      this.$message({
        type: res.type,
        message: res.content,
      });

      if (res.code != 200) {
        fileList = fileList.pop()
      }
    },
    getOrderStatusType(status) {
      const statusTypeMap = {
        '-1': 'danger',
        '0': 'info',
        '1': 'warning',
        '2': 'primary',
        '3': 'success'
      };
      return statusTypeMap[status] || 'info';
    },
    getOrderStatusText(status) {
      const statusMap = {
        '-1': '已取消',
        '0': '未支付',
        '1': '已支付',
        '2': '已发货',
        '3': '已完成'
      };
      return statusMap[status] || '未知状态';
    },
    getPayStatusType(status) {
      const statusTypeMap = {
        '0': 'warning',    // 未支付
        '1': 'success',    // 已支付
        '-1': 'danger',    // 整单退
        '-5': 'info'       // 部分退
      };
      return statusTypeMap[status] || 'info';
    },
    getPayStatusText(status) {
      const statusMap = {
        '0': '未支付',
        '1': '已支付',
        '-1': '整单退',
        '-5': '部分退'
      };
      return statusMap[status] || '未知状态';
    },
    watchOrder(row) {
      let that = this;
      fetchShopOrderDto(row.orderNo).then((res) => {
        that.orderDetail = res.data;
        that.$refs.detailDialog.toggle();
      }).catch((error) => {
        that.$message({
          type: 'error',
          message: '获取订单详情失败：' + (error.message || '未知错误')
        });
      });
    },
    detailOpened() {
      // 弹窗打开时的处理逻辑
    },
    exportData() {
      let that = this;
      
      exportShopOrderDetail({}).then((res) => {
        if (res.code === 200) {
          that.$notify({
            title: "导出成功",
            message: res.content,
            type: "success",
            duration: 10000
          });
          window.location.href = process.env.VUE_APP_BASEURL + res.data;
        } else {
          that.$message({
            type: 'error',
            message: res.content || '导出失败'
          });
        }
      }).catch((error) => {
        that.$message({
          type: 'error',
          message: '导出失败：' + (error.message || '未知错误')
        });
      });
    },
    resetSearch() {
      this.querys.keyword = "";
      this.querys.orderStatus = "";
      this.querys.payStatus = "";
      this.querys.receiverPhone = "";
      this.querys.userId = "";
      this.querys.orderId = "";
      this.fetchs();
    },
    goToRefund(row) {
      // 检查是否满足退款条件
      if (!row || (!row.cancelTime && !row.cancelReason)) {
        this.$message({
          type: 'warning',
          message: '只有已取消的订单才能跳转退款列表'
        });
        return;
      }
      
      // 跳转到退款页面，携带订单编号作为关键词
      this.$router.push({
        path: '/shop/refund',
        query: {
          keyword: row.id
        }
      });
    },
  },
};
</script>
<style lang="less">
.xlsdialog {
  .el-dialog__body {
    max-height: 80vh;
    overflow-y: auto;
  }
}

.el-form .el-date-editor {
  width: 220px;
}

.detail-item {
  margin-bottom: 10px;
}

.detail-item .label {
  font-weight: bold;
  color: #606266;
  margin-right: 8px;
}

.detail-item .value {
  color: #303133;
}

.card-header {
  font-weight: bold;
  font-size: 16px;
}
</style>>



